import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormWrapper from '../../../../../library/form/components/FormWrapper';

const ProdIOTSumOPRow = (props) => {
    const { formObject, viewData, index, rowKey } = props;

    const rowCss = formObject.getValueFromKey(viewData, "dataList.cssClass", "");

    return (
        <ul className={`uiDPEditLine ${rowCss}`}>
            <li className="uiColumnCenter uiColumn50">
                <span>{index}</span>
            </li>
            <li className="uiColumnCenter uiColumn100">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
            </li>
            <li className="uiColumnCenter uiColumn200">
                <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                    action={{ paramName: "actualItem", actionId: "show" }}
                    linkProp={{ target: "_blank" }}
                ></FormLink>
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
            </li>
            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn100" headerKey="viewConfig"
                action={{ paramName: "variation1Name" }} >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
            </FormWrapper>
            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn100" headerKey="viewConfig"
                action={{ paramName: "variation2Name" }} >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
            </FormWrapper>
            <li className="uiColumnCenter uiColumn100">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyReturned" }} />
            </li>
            <li className="uiColumnCenter uiColumn100">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitCost" }} />
            </li>
            <li className="uiColumnCenter uiColumn150">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "remark" }} />
            </li>
            <li className="uiColumnCenter uiColumn50 uiSpacer5">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "status" }} />
            </li>
        </ul>
    )
}

export default ProdIOTSumOPRow
